// Copyright (c) 2016 Deere & Company

import AmountCellRenderer from '../../shared/report-cell-renderers/amount-cell-renderer';
import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {hasAccess} from '../../../shared/services/security';
import {translate} from '../../../shared/services/translation-service';

const getInternalCommentsColumn = security =>
    hasAccess(security, 'TCSM', 'TCSM_LABOR_RATE_READ') ?
    {
        cellClass: classNames.cellLeftClassName,
        colId: 'internalComments',
        field: 'internalComments',
        headerClass: classNames.headerLeftClassName,
        headerName: translate('INTERNAL_DEERE_COMMENTS'),
        width: 250
    } : null;

export function getLaborRateHistoryColumnDefinitions(security) {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerAccount',
            field: 'dealerAccount',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_LOCATION'),
            width: 140
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerName',
            field: 'dealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER_NAME'),
            width: 220
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerState ',
            field: 'dealerState',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STATE'),
            width: 150

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealerCity',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            width: 150
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'processingStatus',
            field: 'processingStatus',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PROCESSING_STATUS'),
            width: 160

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'laborTypeDescription',
            field: 'laborTypeDescription',
            headerClass: classNames.headerClassName,
            headerName: translate('LABOR_TYPE'),
            width: 120
        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'oldLaborRate',
            field: 'oldLaborRate',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('OLD_LABOR_RATE'),
            width: 150

        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'newLaborRate',
            field: 'newLaborRate',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('NEW_LABOR_RATE'),
            width: 150

        },
        {
            cellClass: classNames.cellRightClassName,
            cellRendererFramework: AmountCellRenderer,
            colId: 'averageTechPayRate',
            field: 'averageTechPayRate',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('AVERAGE_TECH_PAY_RATE'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'effectiveDate',
            field: 'effectiveDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('EFFECTIVE'),
            width: 130
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'requestDate',
            field: 'requestDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REQUESTED'),
            width: 130

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'requestedBy',
            field: 'requestedBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REQUESTED_BY'),
            width: 130

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'reasonForChange',
            field: 'reasonForChange',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REASON_FOR_CHANGE'),
            width: 250
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'decisionDate',
            field: 'decisionDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('APPROVED_REJECTED'),
            width: 200

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'deereRemarks',
            field: 'deereRemarks',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEERE_REMARKS'),
            width: 250
        },
        getInternalCommentsColumn(security)
    ].filter(column => column !== null);

}



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/report-services/column-definitions.js